module.exports = __webpack_public_path__ + "static/media/4.5de537e9.jpg";